import { Client, ClientsFilter, EventClientsTable } from '@entities/clients';
import { useEffect } from 'react';

interface ListParticipantsTabProps {
  clients: Client[] | undefined;
  allClients?: Client[];
  fetching: boolean;
  eventId: number;
  searchValue: string;
  handleSearchChange: (value: string) => void;
  handleOrderChange: (value: string[] | null) => void;
  handleFilterChange: (value: ClientsFilter) => void;
  refetch: () => void;
  dateStart?: string;
}

export const ListParticipantsTab = ({
  clients,
  allClients,
  fetching,
  eventId,
  searchValue,
  handleSearchChange,
  handleOrderChange,
  handleFilterChange,
  refetch,
  dateStart,
}: ListParticipantsTabProps) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      handleSearchChange(searchValue);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchValue, handleSearchChange]);

  return (
    <EventClientsTable
      clients={clients || []}
      allClients={allClients}
      isLoading={fetching}
      eventId={eventId}
      handleOrderChange={handleOrderChange}
      handleFilterChange={handleFilterChange}
      refetchClients={refetch}
      dateStart={dateStart}
    />
  );
};
